import React, { useEffect } from "react";
import Button from "./components/Button";
import queryString from "query-string";
import * as styled from "./styled.js";

const DEV_URL_OVERRIDE = process.env.REACT_APP_URL_OVERRIDE;

function App() {
  const canvasLinks = [
    {
      name: "Asia Pacific",
      url: DEV_URL_OVERRIDE || "https://canvas.bluedot.io",
    },
    {
      name: "Europe",
      url: DEV_URL_OVERRIDE || "https://eu1-canvas.bluedot.io",
    },
    {
      name: "North America",
      url: DEV_URL_OVERRIDE || "https://us1-canvas.bluedot.io",
    },
  ];

  // This logic is specific to the Attentive integration, where the callback URL may already know
  // the target region if it has been triggered from Canvas
  useEffect(() => {
    if (window.location.search) {
      const queryParams = queryString.parse(window.location.search);
      if (queryParams.state) {
        try {
          const decodedStateString = atob(queryParams.state);
          const stateObject = JSON.parse(decodedStateString);
          if (stateObject.region) {
            const targetLink = canvasLinks.find(
              (link) => link.name === stateObject.region
            );
            if (targetLink) {
              window.location.assign(
                `${targetLink.url}${window.location.pathname}${window.location.search}`
              );
            } else if (stateObject.region === "Asia Pacific Dev") {
              window.location.assign(
                `https://canvas-dev-1.dev-bluedot.com${window.location.pathname}${window.location.search}`
              );
            }
          }
        } catch (error) {
          console.log("invalid state parameter, ignoring", error);
        }
      }
    }
  });

  return (
    <styled.Container>
      <styled.Content>
        <styled.MainContentContainer>
          <styled.Logo src="/assets/images/rezolve-ai-logo-black.svg" alt="logo" />
          <h4>Select your region</h4>
          <styled.ButtonsWrapper>
            {canvasLinks.map((link) => (
              <a
                key={link.name}
                href={`${link.url}${window.location.pathname}${window.location.search}`}
              >
                <Button>{link.name}</Button>
              </a>
            ))}
          </styled.ButtonsWrapper>
        </styled.MainContentContainer>

        <styled.SupportMessageContainer>
          <p>
            Not sure which region to use? Contact your Rezolve AI admin.
          </p>
        </styled.SupportMessageContainer>
      </styled.Content>
    </styled.Container>
  );
}

export default App;
